import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    border: `${theme.palette.cardBorder.main} solid 1px`,
    minHeight: theme.spacing(36.75),
    backgroundColor: theme.palette.text.white,
    position: 'relative',
    marginTop: theme.spacing(3),
  },
  dimensionsHeader: {
    backgroundColor: theme.palette.secondary.main,
    borderBottom: `${theme.palette.cardBorder.main} solid 1px`,
    padding: theme.spacing(2, 0, 2.125, 3),
  },
  heading: {
    color: theme.palette.text.primary,
    fontSize: '22px',
    textAlign: 'left',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  dimensionsBody: {
    padding: theme.spacing(3),
    minHeight: theme.spacing(22.75),
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  selectionHeading: {
    color: theme.palette.black.main,
    fontSize: '14px',
    textAlign: 'left',
    margin: theme.spacing(1.75, 0, 2, 0),
  },
  eula: {
    padding: theme.spacing(3),
    textAlign: 'left',
    border: `${theme.palette.cardBorder.main} 1px solid`,
    marginBottom: theme.spacing(2),
    borderRadius: '4px',
  },
  exceptionalEula: {
    display: 'flex',
    flexDiretion: 'row',
    alignItems: 'center',
  },
  eulaForm: {
    width: '100%',
  },
  radio: {
    width: '24px',
    height: '24px',
    padding: theme.spacing(0, 2, 0, 1),
    '&.MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.labraCheckbox.main,
    },
    '&.MuiRadio-root': {
      color: theme.palette.cardBorder.main,
    },
  },
  eulaLabel: {
    fontSize: '16px',
    '&.MuiFormControlLabel-root': {
      marginRight: theme.spacing(1.75),
    },
  },
  customEulaContainer: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(5),
  },
  customSubheading: {
    fontSize: '14px',
    marginTop: theme.spacing(0.625),
    color: theme.palette.detailedRecipientText.main,
  },
  uploadButton: {
    marginTop: theme.spacing(4),
    border: `${theme.palette.opaque.dark} 1px solid`,
    color: theme.palette.opaque.dark,
    width: '181px',
    cursor: 'pointer',
    padding: theme.spacing(1.25, 0, 1.25, 0),
    position: 'relative',
  },
  alertBox: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.opaque.light,
    width: '359px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  uploadIcon: {
    margin: theme.spacing(0.25, 1.75, 0, 4.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  infoIconSmall: {
    color: theme.palette.icon.main,
    margin: theme.spacing(0.375, 1.125, 0, 0),
    '&.MuiSvgIcon-root': {
      height: '12px',
      width: '12px',
    },
  },
  alertText: {
    color: theme.palette.detailedRecipientText.main,
    fontSize: '12px',
  },
  fileUpload: {
    cursor: 'pointer',
    opacity: 0,
    MozOpacity: 0,
    KhtmlOpacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
  },
  eulaBoxShadow: {
    boxShadow: `0px 20px 40px ${theme.palette.boxShadow.main}`,
    border: `${theme.palette.opaque.dark} 1px solid`,
  },
  file: {
    width: '287px',
    padding: theme.spacing(1.5, 0, 1.5, 2.5),
    backgroundColor: theme.palette.secondary.main,
    border: `${theme.palette.check.light} 1px solid`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  fileName: {
    fontSize: '16px',
    color: theme.palette.detailedRecipientText.main,
    lineHeight: 1.2,
    wordBreak: 'break-all',
    paddingRight: theme.spacing(5),
  },
  closeIconButton: {
    right: theme.spacing(1.875),
    position: 'absolute',
    '&.MuiIconButton-root': {
      padding: theme.spacing(0),
    },
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
    },
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.25),
    marginTop: theme.spacing(2.5),
    flexWrap: 'wrap',
  },
  uploadButtonText: {
    fontSize: '12px',
    fontWeight: 600,
  },
  uploadButtonLabel: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
  },
  serviceHeading: {
    fontSize: '16px',
  },
  openNewIcon: {
    color: theme.palette.select.light,
    '&.MuiSvgIcon-root': {
      height: '18px',
      width: '18px',
    },
  },
  disabledUplaod: {
    cursor: 'inherit',
  },
  disabledDiv: {
    opacity: '0.3',
    cursor: 'inherit',
  },
}))
